import { CheckBox } from 'src/UI';
import { DECLINE_SYMBOL } from 'src/Constants';
import { declineWordByNumber } from 'src/Utils/declineWordByNumber';
import { FC, ReactNode } from 'react';
import { useSearchMark } from 'src/Hooks';
import classNames from 'classnames';
import st from './SelectBox.module.scss';

interface ISelectBoxBodyProps {
	minSearchLength?: number;
	/** Флаг загрузки списка */
	isWait?: boolean;
	multiple?: boolean;
	searchText: string;
	selectedIds: string[];
	options: any[];
	valueField: string;
	titleField: string;
	onClickOption: (item: any) => void;
	onRenderOption?: (
		item: any,
		isSelected: boolean,
		searchText: string,
		index: number,
		getHtml: (source: string, searchText: string) => string,
	) => ReactNode;
	renderListTb?: () => ReactNode;
	onScroll?: (e: any) => void;
}

/** Контент выпадающего списка */
const SelectBoxBody: FC<ISelectBoxBodyProps> = (props) => {
	const {
		minSearchLength = 0,
		isWait = false,
		searchText,
		selectedIds = [],
		multiple = false,
		options = [],
		valueField,
		titleField,
		onClickOption,
		renderListTb,
		onRenderOption,
		onScroll,
	} = props;

	// Для подсветки найденных значений
	const { getHtml } = useSearchMark(st.markItem);

	/** Возвращает  */
	const getHelperMessage = () => {
		const length = minSearchLength - searchText.length;
		if (isWait) {
			return 'Ведется поиск...';
		} else if (minSearchLength > 0 && length > 0) {
			return `Введите минимум ${minSearchLength} ${declineWordByNumber(
				minSearchLength,
				DECLINE_SYMBOL,
			)}`;
		} else if (!options.length) {
			return 'Совпадений не найдено';
		}
		return '';
	};

	/** Отрисовка опции выпадающего списка */
	const renderOption = (item: any, index: number) => {
		const value = item[valueField];
		const title = item?.isNew ? item.newTitle : item[titleField];
		const isSelected = selectedIds.includes(value);
		return (
			<li
				key={'item__' + value + '-' + index}
				className={classNames(st.item, { [st.selected]: isSelected })}
				onClick={() => {
					return onClickOption(item);
				}}
			>
				{multiple && (
					<CheckBox
						name={'optionCB' + index}
						value={isSelected}
						className={st.checkBox}
					/>
				)}
				{onRenderOption ? (
					onRenderOption(item, isSelected, searchText, index, getHtml)
				) : (
					<div
						dangerouslySetInnerHTML={{
							__html: getHtml(title, searchText),
						}}
					/>
				)}
			</li>
		);
	};

	/** Отрисовка сообщения */
	const renderMessage = () => {
		const message = getHelperMessage();
		if (!message) {
			return null;
		}
		return <p className={st.message}>{message}</p>;
	};

	return (
		<>
			{renderMessage()}
			<ul className={st.listWrapper} onScroll={onScroll}>
				{options.map(renderOption)}
			</ul>
			{!!renderListTb && renderListTb()}
		</>
	);
};

export default SelectBoxBody;
